import { Props as SelectProps } from "react-select";
import { useEffect, useState } from "react";

import { GrievanceNotification } from "@/@types/sintegrada/GrievanceNotification";
import { Option } from "@/@types/generics/Option";
import { getGrievanceNotifications } from "@/services/sintegrada/grievanceNotification/getGrievanceNotification";
import { useCurrentAccount } from "@/hooks/useCurrentAccount";

import { SelectComponent } from "@/components/SelectComponent";

type Props = SelectProps & {
	noDefaultOption?: boolean;
};

export const defaultGrievanceNotification = { value: null, label: "Todas as Notificações" };

export function GrievanceNotificationSelect({ noDefaultOption, ...rest }: Props) {
	const { uf, ibgeCode, cnes } = useCurrentAccount();
	const [grievanceNotifications, setGrievanceNotifications] = useState<GrievanceNotification[]>(
		[]
	);

	let options: Option<GrievanceNotification | null>[] = [
		...grievanceNotifications?.map((grievanceNotification) => ({
			value: grievanceNotification,
			label: grievanceNotification.name,
		})),
	];
	if (!noDefaultOption) {
		options = [defaultGrievanceNotification, ...options];
	}

	async function handleGrievanceNotifications() {
		setGrievanceNotifications(await getGrievanceNotifications({ uf, ibgeCode, cnes }));
	}

	useEffect(() => {
		handleGrievanceNotifications();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="d-flex flex-column justify-content-between h-100">
			<label
				title="Notificações de agravo"
				className="form-label"
				htmlFor="grievance-notification"
			>
				Notificações de agravo:
			</label>

			<SelectComponent
				inputId="grievance-notification"
				className="fs-8"
				options={options}
				placeholder="Selecione..."
				noOptionsMessage={() => "Nenhuma notificação encontrada"}
				{...rest}
			/>
		</div>
	);
}
